module.exports = __webpack_public_path__ + "img/icon-afternoon.ffe1c3df.svg";